export enum MessageRole {
  User = 'user',
  Assistant = 'assistant',
}

export type AiAssistantUserType = 'user' | 'user_manager'

export type AiAssistantConversationType = 'skill' | 'platform'

export type AiAssistantLanguage = 'en' | 'sv'

export interface AiAssistantInitRequest {
  userType: AiAssistantUserType
  conversationType: AiAssistantConversationType
  language: AiAssistantLanguage
  message?: string
}

export const AI_ASSISTANT_QUICK_ACTION_LINKS = [
  'career_goals',
  'interests',
  'unused_skills',
  'skill_assessment',
  'my_team_overview',
  'my_team_skill_gaps',
  'my_team_performance',
  'my_team_performance_create',
  'my_team_dashboard',
  'project_builder',
  'users',
  'organisation',
] as const

export type AiAssistantQuickActionLink = typeof AI_ASSISTANT_QUICK_ACTION_LINKS[number]

export interface AiAssistantAction {
  label: string
  suggestion: string
  linkTo?: AiAssistantQuickActionLink | null
  linkParams?: {
    skillName?: string
  }
}

export interface AiAssistantInitResponse {
  answer: string
  suggestedPrompts: string[]
  actions?: AiAssistantAction[]
}

export type AssistantMessage = {
  id: string
  role: MessageRole
  content: string
  timestamp: Date
  isGreeting?: boolean
}
